import { Icon } from '@iconify/react';
import RevealWrap from './RevealWrap';

export default function CTABridge() {
  return (
    <section className="py-28 lg:py-40 bg-neutral-950 text-white relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-400/6 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-3xl mx-auto px-6 lg:px-8 relative z-10 text-center">
        <RevealWrap animation="scale">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-card mb-8">
            <span className="w-2 h-2 rounded-full bg-brand-400 animate-pulse" />
            <span className="text-neutral-400 text-sm font-medium">지금 시작하세요</span>
          </div>

          <h2 className="text-3xl lg:text-5xl font-bold leading-tight tracking-tight mb-5">
            첫 달은 무료입니다.<br />
            <span className="gradient-text">부담 없이 시작하세요.</span>
          </h2>
          <p className="text-neutral-400 text-lg leading-relaxed mb-10 max-w-md mx-auto">
            전화 한 통이면 매장에 딱 맞는 솔루션을 확인하실 수 있습니다.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <div className="relative">
              <div className="absolute -inset-3 bg-brand-400/20 rounded-2xl blur-xl animate-pulse" />
              <a
                href="tel:1644-6827"
                className="relative group inline-flex items-center gap-3 px-10 py-5 bg-brand-400 text-neutral-900 font-bold rounded-xl hover:bg-brand-500 transition-all duration-300 text-lg"
              >
                <Icon icon="solar:phone-bold" className="text-xl" />
                1644-6827
              </a>
            </div>
            <a
              href="http://pf.kakao.com/_fgiMX/chat"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 px-8 py-5 glass-card text-white font-semibold rounded-xl hover:bg-white/10 transition-all duration-300 text-base"
            >
              <Icon icon="solar:chat-round-dots-bold" className="text-xl" />
              카카오톡 상담
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-neutral-400">
            {[
              { icon: 'solar:check-circle-bold', text: '첫 1개월 무료' },
              { icon: 'solar:check-circle-bold', text: '설치비 무료' },
              { icon: 'solar:check-circle-bold', text: '추가 과금 없음' },
            ].map((t) => (
              <span key={t.text} className="flex items-center gap-2">
                <Icon icon={t.icon} className="text-brand-400 text-base" />
                {t.text}
              </span>
            ))}
          </div>
        </RevealWrap>
      </div>
    </section>
  );
}
